import { EMR_APIS } from "@/api_framework/api_config";
import { IAISummaryResponse } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useAISummaryAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [aiSummary, setAiSummary] = useState<IAISummaryResponse | null>(null);

  const toggleLoading = (status: boolean) => {
    dispatch(
      setLoading({
        key: "isAISummaryFetchInProgress",
        status,
      }),
    );
  };

  const execute = useCallback(
    async (petId: string) => {
      toggleLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .get(`${EMR_APIS?.AI_SUMMARY?.baseURL}${petId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAISummaryResponse>) => {
            toggleLoading(false);
            if (res.data && res.data.data) {
              setAiSummary(res.data);
            } else {
              setAiSummary(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            toggleLoading(false);
            if (e.status === 400 || e.code === "ERR_BAD_REQUEST") {
              setAiSummary(null);
              // toast("No AI summary found");
            } else {
              toast.error("Failed to fetch AI summary");
            }
          });
      } catch (e: any) {
        toggleLoading(false);
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch, configuration.localStorage.ACCESS_TOKEN.key],
  );

  return { execute, aiSummary };
}; 